import { BooleanBase } from '../BooleanBase';

export class CTVRON extends BooleanBase {}
